import script from "./MultipleGames.vue?vue&type=script&setup=true&lang=js"
export * from "./MultipleGames.vue?vue&type=script&setup=true&lang=js"

import "./MultipleGames.vue?vue&type=style&index=0&id=64784d6f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64784d6f"]])

export default __exports__